











import { defineComponent } from "@vue/composition-api";
import ImagePreview from "@/components/ImagePreview";

export default defineComponent({
  name: "PayeeInfoPreview",
  components: { ImagePreview },
  props: {
    imageSrc: { type: String },
  },
});
